import { StatsigClient } from '@statsig/js-client';

import { EligibilityState } from '@/lib/eligibility/eligibilitySlice';

/**
 * True when the `eligibility_claiming` gate is on and eligibility.lineItems
 * are populated in state — i.e. the user is going through the eligibility
 * claiming flow rather than the classic order flow.
 *
 * Pass the eligibility slice (from `useEligibilityData()`) in; the gate is
 * read off the StatsigClient singleton so this can be used outside of a
 * component too.
 */
const checkEligibilityFlow = (eligibility: EligibilityState): boolean => {
  const eligibilityClaimingEnabled = StatsigClient.instance().checkGate(
    'eligibility_claiming',
  );
  return eligibilityClaimingEnabled && (eligibility.lineItems?.length ?? 0) > 0;
};

export default checkEligibilityFlow;
